import { z } from 'zod';

const flag = z
  .union([z.boolean(), z.enum(['true', 'false'])])
  .transform((value) => value === true || value === 'true');

/** What goes into an exported PDF and how it is set. Sent as query parameters. */
export const exportOptionsSchema = z
  .object({
    /** First and last section to include, by index; the whole document by default. */
    from: z.coerce.number().int().min(0).default(0),
    to: z.coerce.number().int().min(0).optional(),
    pageSize: z.enum(['a4', 'letter', 'a5']).default('a4'),
    typeface: z.enum(['serif', 'sans']).default('serif'),
    textSize: z.enum(['small', 'medium', 'large']).default('medium'),
    titlePage: flag.default(true),
    contents: flag.default(true),
    pageNumbers: flag.default(true),
    /** An appendix with the reader's own bookmarks and notes in this document. */
    notes: flag.default(false),
  })
  .refine((options) => options.to === undefined || options.to >= options.from, {
    message: 'The last section must come after the first',
    path: ['to'],
  });
export type ExportOptions = z.infer<typeof exportOptionsSchema>;
